import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
// import {TableComp} from 'sz-react-utils'
import TableComp from '../../../components/_utils/table'

import moment from 'moment'
import {Button, Card, DatePicker, Drawer, Icon} from 'antd'
import Request from '../../../request'
import {connect} from 'react-redux'
import renderHTML from 'react-render-html'

const { RangePicker } = DatePicker
//let itemCount = 20
//let itemPage = 0
class AllEmails extends Component {

  state = {
    count: 0,
    time: {
      key: 'time',
      from: null,
      to: null
    },
    visible1: false

  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  showDrawer1 = () => {
    this.setState({
      visible1: true
    })
  }

  renderDetails = (record) => {

    if (record.html) {
      let u = record.html
      if (u.length <= 200) {
        return <div>{u ? renderHTML(u) : 'N/A'}</div>

      } else {
        u = u.slice(25, 70)
        return <div style={{ display: 'flex' }}> {u ? renderHTML(u) : 'N/A'}
          <Button style={{
            marginLeft: '10px',
            padding: '3px',
            height: '23px'
          }} type="primary" onClick={() => {
            this.showDrawer1()
            this.setState({ emailDetails: record.html })
          }}>{<Icon type="eye"/>}</Button>
        </div>
      }
    }
  }

  chooseRangerPicker = (date, dateString) => {

    this.setState({
      time: {
        key: 'time',
        from: date[0],
        to: date[1]
      }
    }, () => {
      console.log(this.state.time, '@@@@@@@@@@@@@@@@@@@')

    })


    if (date[0] === undefined) {
      setTimeout(() => {
        this.reload()
      }, 500)
    }
  }

  reload = () => {
    this.table.current.reload()
  }

  apiRequest = (params, columns) => {
    return new Promise(async resolve => {
      // if (params.page && params.count) {
      //   itemPage = params.page && params.page - 1
      //   itemCount = params.count && params.count
      // }
      if (!params.sortField) {
        params.sortField = 'date'
        params.sortOrder = 'descend'
      }
      let data = await Request.loadAllEmails({
        ...params,
        regExFilters: ['email'],
        sortedDate: this.state && this.state.time

      })
      delete data.error
      delete data.type

      this.setState({ count: data.total })

      resolve(data)
    })
  }

  async componentDidMount() {

  }

  render() {
    const columns = [
      // {
      //   title: 'Sr No.',
      //   key: 'sr',
      //   dataIndex: 'sr',
      //   render: (val, record, key) => {
      //     return <div>{itemPage * itemCount + key + 1}</div>
      //   }
      // },
      // {
      //   title: 'Student Details',
      //   key: 'studentId',
      //   dataIndex: 'studentId',
      //   render: (val, record) => {
      //     console.log(val,"recooooo",record)
      //     return <React.Fragment>
      //       <Tooltip title="Click To View Details">
      //         <a className={styles.btn} target={'_blank'}
      //            href={`/inquiry/studentProfileDetails?id=${val && val._id}`}
      //         >{val.studentName}</a>
      //       </Tooltip>
      //
      //       <div>
      //
      //         <div>{val ? val.mobile : ''}</div>
      //         <div>{val ? val.email : ''}</div>
      //         <div>{val ? val.gender : ''}</div>
      //       </div>
      //     </React.Fragment>
      //   }
      // },
      {
        title: 'subject',
        key: 'subject',
        dataIndex: 'subject'
        //searchTextName: 'subject',
      },
      {
        title: 'Email',
        key: 'to',
        dataIndex: 'to',
        searchTextName: 'email'
      },
      {
        title: 'Details',
        key: 'html',
        dataIndex: 'html',
        // searchTextName: 'html',
        render: (val, record) => {
          return this.renderDetails(record)
        }
      },
      {
        title: 'Date',
        key: 'date',
        dataIndex: 'date',
        render: (val, record) => {
          return (<div> {val && moment(val).format('DD-MMM-YYYY hh:mm:A')} </div>)
        }
      }
    ]
    return (
      <PageHeaderWrapper title={` All Communication Emails : ${this.state.count} `}>
        <Card bordered={true}>
          <h4>FILTER BY DATE</h4>
          <RangePicker
            showTime={{ format: 'HH:mm' }}
            defaultValue={[moment().startOf('day'), moment().endOf('day')]}
            format="YYYY-MM-DD HH:mm"
            placeholder={['Start Time', 'End Time']}
            onChange={this.chooseRangerPicker}
            onOk={this.reload}
          />
          <TableComp
            showSelector={true}
            columns={columns}
            ref={this.table}
            apiRequest={params => this.apiRequest(params, columns)}
            extraProps={{ scroll: { x: 800 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 20,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card>

        {!!this.state.visible1 && <Drawer
          title=""
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              visible1: false
            })
          }}
          visible={this.state.visible1}
          width={1000}>
          {this.state && this.state.emailDetails && <div>
            <h2 style={{
              marginLeft: '11px',
              marginTop: '13px',
              color: 'orange'

            }}>Email Details</h2>

            <p style={{
              padding: '10px',
              textAlign: 'justify',
              marginLeft: '4px',
              marginRight: '50px'

            }}>{this.state.emailDetails ? renderHTML(this.state.emailDetails) : null}
            </p>
          </div>}
        </Drawer>}
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllEmails)
